// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Subtract.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services .custom-shape-divider-bottom-1689675804 {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
}
.services .custom-shape-divider-bottom-1689675804 svg {
  position: relative;
  display: block;
  width: calc(100% + 1.3px);
  height: 23px;
}
@media only screen and (min-width: 768px) {
  .services .custom-shape-divider-bottom-1689675804 svg {
    height: 31px;
  }
}
@media only screen and (min-width: 1440px) {
  .services .custom-shape-divider-bottom-1689675804 svg {
    height: 165px;
  }
}
.services .custom-shape-divider-bottom-1689675804 .shape-fill {
  fill: #FFFFFF;
}
.services-title {
  color: #000;
  font-size: 18px;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 20px;
}
@media only screen and (min-width: 1440px) {
  .services-text {
    width: 80%;
  }
}
.services-header {
  height: 414px;
  position: relative;
  background-color: #FCAF17;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 5% 45px 5%;
  z-index: 1;
}
@media screen and (min-width: 415px) {
  .services-header {
    height: 370px;
    padding: 0px 10% 45px 10%;
  }
}
@media only screen and (min-width: 769px) {
  .services-header {
    height: 446px;
    padding: 0px 17% 45px 17%;
  }
}
.services-header-title__text {
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 43px;
  margin-bottom: 16px;
}
@media only screen and (min-width: 768px) {
  .services-header-title__text {
    font-size: 44px;
    line-height: 66px;
  }
}
@media only screen and (min-width: 1440px) {
  .services-header-title__text {
    font-size: 64px;
    line-height: 70px;
  }
}
.services-header-subtitle__text {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  padding: 0px 13%;
}
@media only screen and (min-width: 768px) {
  .services-header-subtitle__text {
    padding: 0px 16%;
  }
}
@media only screen and (min-width: 1440px) {
  .services-header-subtitle__text {
    padding: 0px 22%;
  }
}
.services-bg-image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  background-size: cover;
  position: absolute;
  z-index: 2;
  height: 400px;
  width: 100%;
  margin-top: -154px;
}
@media screen and (max-width: 1440px) {
  .services-bg-image {
    margin-top: -125px;
  }
}
@media screen and (max-width: 1024px) {
  .services-bg-image {
    background-size: contain;
    margin-top: -125px;
  }
}
@media screen and (max-width: 768px) {
  .services-bg-image {
    display: none;
  }
}
.services-broadcast {
  background-color: #F2F2F7;
  width: 100%;
  position: relative;
  z-index: 3;
  padding-bottom: 60px;
}
@media only screen and (min-width: 768px) {
  .services-broadcast {
    display: flex;
  }
}
.services-broadcast__text-frame {
  padding: 25px 30px;
  z-index: 3;
}
@media only screen and (min-width: 768px) {
  .services-broadcast__text-frame {
    width: 50%;
  }
}
.services-broadcast__title {
  font-size: 18px;
  font-weight: 700;
  line-height: 120%;
  margin-top: 16px;
  margin-bottom: 20px;
}
.services-broadcast__text {
  color: #757575;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 23px;
}
.services-broadcast img {
  width: 32px;
  padding-bottom: 40px;
}
@media only screen and (min-width: 1440px) {
  .services-broadcast__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
.services-broadcast__list-item {
  display: flex;
  gap: 15px;
  background-color: white;
  border-radius: 40px;
  padding: 10px 15px;
  margin-bottom: 8px;
  height: 46px;
  width: -moz-fit-content;
  width: fit-content;
}
.services-broadcast__list-item .text {
  font-size: 11px;
  padding-top: 4px;
}
@media only screen and (min-width: 1440px) {
  .services-broadcast__list-item .text {
    font-size: 16px;
  }
}
.services-broadcast__img {
  padding-top: 20px;
  z-index: 3;
}
@media only screen and (min-width: 768px) {
  .services-broadcast__img {
    width: 50%;
  }
}
.services-broadcast__img img {
  width: 100%;
  height: 518px;
  padding-left: 30px;
}
@media only screen and (min-width: 768px) {
  .services-broadcast__img img {
    padding-left: 10px;
  }
}
@media only screen and (min-width: 1440px) {
  .services-broadcast__img img {
    height: 626px;
    width: 598px;
    position: absolute;
    right: 0;
  }
}
@media only screen and (min-width: 768px) {
  .services-item {
    display: flex;
  }
}
.services-item__img {
  margin: 24px 0;
  padding-right: 30px;
}
@media only screen and (min-width: 768px) {
  .services-item__img {
    margin: 64px 0;
  }
}
.services-item__img img {
  width: 100%;
}
@media only screen and (min-width: 768px) {
  .services-item__img img {
    width: 433px;
  }
}
@media only screen and (min-width: 1440px) {
  .services-item__img img {
    width: 821px;
    height: 310px;
  }
}
.services-item__text {
  color: #757575;
  font-weight: 400;
  line-height: 150%;
  padding: 10px 30px;
}
@media only screen and (min-width: 768px) {
  .services-item__text {
    padding: 64px 30px;
  }
}
.services .badgetitle {
  font-size: 14px;
  font-weight: 700;
  line-height: 140%;
  color: #FCAF17;
  border-radius: 40px;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  display: inline-block;
  padding: 4px 16px;
  margin-bottom: 16px;
}
.services-second-area img {
  width: 100%;
  padding: 0 42px;
}
.services-second-area:nth-of-type(2) img {
  margin: 34px 0 80px 0;
}
.services-right__img {
  background-color: #F2F2F7;
  padding: 18px 0;
}
@media only screen and (min-width: 768px) {
  .services-right__img .services-item {
    flex-direction: row-reverse;
  }
}
.services-right__img .services-item__img {
  padding-right: 0;
}
.services-right__img .services-item__img img {
  padding-left: 30px;
}
@media only screen and (min-width: 1440px) {
  .services-right__img .services-item__img img {
    width: 598px;
    height: 310px;
  }
  .services-right__img .services-item__img img.screen-room {
    height: 610px;
  }
}
.services-content {
  margin-top: 25px;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}
@media only screen and (min-width: 1440px) {
  .services-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
.services-content-item {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  color: #18181C;
}
@media only screen and (min-width: 1440px) {
  .services-content-item {
    background: white;
    width: max-content;
    padding: 10px;
    border-radius: 50px;
  }
}
.services .marklist {
  grid-template-columns: repeat(4, 1fr);
  display: grid;
  margin-top: 24px;
}
@media only screen and (min-width: 768px) {
  .services .marklist {
    grid-template-columns: repeat(4, 50%);
  }
}
@media only screen and (min-width: 1440px) {
  .services .marklist {
    grid-template-columns: repeat(4, 1fr);
    margin-top: 0;
    width: 83%;
  }
}
.services .marklist img {
  margin: auto;
  width: 100%;
  padding-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/styles/Services.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGE;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AADJ;AAGI;EANF;IAOI,YAAA;EAAJ;AACF;AAEI;EAVF;IAWI,aAAA;EACJ;AACF;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AADJ;AAKI;EADF;IAEI,UAAA;EAFJ;AACF;AAKE;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;AAHJ;AAII;EAVF;IAWI,aAAA;IACA,yBAAA;EADJ;AACF;AAEI;EAdF;IAeI,aAAA;IACA,yBAAA;EACJ;AACF;AACI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACN;AAAM;EANF;IAOI,eAAA;IACA,iBAAA;EAGN;AACF;AADM;EAXF;IAYI,eAAA;IACA,iBAAA;EAIN;AACF;AADI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAGN;AAFM;EANF;IAOI,gBAAA;EAKN;AACF;AAJM;EATF;IAUI,gBAAA;EAON;AACF;AAJE;EACE,6DAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AAMJ;AALI;EARF;IASM,kBAAA;EAQN;AACF;AAPI;EAXF;IAYI,wBAAA;IACE,kBAAA;EAUN;AACF;AATI;EAfF;IAgBM,aAAA;EAYN;AACF;AATE;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AAWJ;AATI;EAPF;IAQI,aAAA;EAYJ;AACF;AAVI;EACE,kBAAA;EACA,UAAA;AAYN;AAXM;EAHF;IAII,UAAA;EAcN;AACF;AAXI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAaN;AAVI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAYN;AATI;EACE,WAAA;EACA,oBAAA;AAWN;AANM;EAFF;IAGI,aAAA;IACA,qCAAA;EASN;AACF;AAPM;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;AASR;AAPQ;EACE,eAAA;EACA,gBAAA;AASV;AAPU;EAJF;IAKI,eAAA;EAUV;AACF;AALI;EACE,iBAAA;EACA,UAAA;AAON;AANM;EAHF;IAII,UAAA;EASN;AACF;AAPM;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AASR;AAPQ;EALF;IAMI,kBAAA;EAUR;AACF;AARQ;EATF;IAUI,aAAA;IACA,YAAA;IACA,kBAAA;IACA,QAAA;EAWR;AACF;AALI;EADF;IAEI,aAAA;EAQJ;AACF;AANI;EACE,cAAA;EACA,mBAAA;AAQN;AANM;EAJF;IAKI,cAAA;EASN;AACF;AAPM;EACE,WAAA;AASR;AAPQ;EAHF;IAII,YAAA;EAUR;AACF;AARQ;EAPF;IAQI,YAAA;IACA,aAAA;EAWR;AACF;AAPI;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AASN;AAPM;EANF;IAOI,kBAAA;EAUN;AACF;AANE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,sCAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AAQJ;AAJG;EACC,WAAA;EACA,eAAA;AAMJ;AAFI;EACE,qBAAA;AAIN;AACE;EACE,yBAAA;EACA,eAAA;AACJ;AAGM;EAFF;IAGI,2BAAA;EAAN;AACF;AAEM;EACE,gBAAA;AAAR;AAEQ;EACE,kBAAA;AAAV;AAEU;EAHF;IAII,YAAA;IACA,aAAA;EACV;EACU;IACE,aAAA;EACZ;AACF;AAME;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAJJ;AAMI;EANF;IAOI,aAAA;IACA,qCAAA;EAHJ;AACF;AAKI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AAHN;AAKM;EANF;IAOI,iBAAA;IACA,kBAAA;IACA,aAAA;IACA,mBAAA;EAFN;AACF;AAME;EACE,qCAAA;EACA,aAAA;EACA,gBAAA;AAJJ;AAMI;EALF;IAMI,qCAAA;EAHJ;AACF;AAKI;EATF;IAUI,qCAAA;IACA,aAAA;IACA,UAAA;EAFJ;AACF;AAII;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAFN","sourcesContent":[".services {\n  .custom-shape-divider-bottom-1689675804 {\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    width: 100%;\n    overflow: hidden;\n    line-height: 0;\n  }\n  \n  .custom-shape-divider-bottom-1689675804 svg {\n    position: relative;\n    display: block;\n    width: calc(100% + 1.3px);\n    height: 23px;\n\n    @media only screen and (min-width: 768px) {\n      height: 31px;\n    }\n\n    @media only screen and (min-width: 1440px) {\n      height: 165px;\n    }\n  }\n  \n  .custom-shape-divider-bottom-1689675804 .shape-fill {\n    fill: #FFFFFF;\n  }\n\n  &-title {\n    color: #000;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 120%;\n    margin-bottom: 20px;\n  }\n\n  &-text {\n    @media only screen and (min-width: 1440px) {\n      width: 80%;\n    }\n  }\n\n  &-header {\n    height: 414px;\n    position: relative;\n    background-color: #FCAF17;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0px 5% 45px 5%;\n    z-index: 1;\n    @media screen and (min-width: 415px) {\n      height: 370px;\n      padding: 0px 10% 45px 10%;\n    }\n    @media only screen and (min-width: 769px) {\n      height: 446px;\n      padding: 0px 17% 45px 17%;\n    }\n\n    &-title__text {\n      font-size: 36px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: 43px;\n      margin-bottom: 16px;\n      @media only screen and (min-width: 768px) {\n        font-size: 44px;\n        line-height: 66px;\n      }\n  \n      @media only screen and (min-width: 1440px) {\n        font-size: 64px;\n        line-height: 70px;\n      }\n    }\n\n    &-subtitle__text {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      padding: 0px 13%;\n      @media only screen and (min-width: 768px) {\n        padding: 0px 16%;\n      }\n      @media only screen and (min-width: 1440px) {\n        padding: 0px 22%;\n      }\n    }\n  }\n  &-bg-image {\n    background: url(\"../../assets/images/Subtract.png\") no-repeat;\n    background-size: cover;\n    position: absolute;\n    z-index: 2;\n    height: 400px;\n    width: 100%;\n    margin-top: -154px;\n    @media screen and (max-width: 1440px) {\n        margin-top: -125px;\n    }\n    @media screen and (max-width: 1024px) {\n      background-size: contain;\n        margin-top: -125px;\n    }\n    @media screen and (max-width: 768px) {\n        display: none;\n    }\n  }\n\n  &-broadcast {\n    background-color: #F2F2F7;\n    width: 100%;\n    position: relative;\n    z-index: 3;\n    padding-bottom: 60px;\n\n    @media only screen and (min-width: 768px) {\n      display: flex;\n    }\n\n    &__text-frame {\n      padding: 25px 30px;\n      z-index: 3;\n      @media only screen and (min-width: 768px) {\n        width: 50%;\n      }\n    }\n\n    &__title {\n      font-size: 18px;\n      font-weight: 700;\n      line-height: 120%;\n      margin-top: 16px;\n      margin-bottom: 20px;\n    }\n\n    &__text {\n      color:#757575;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n      margin-bottom: 23px;\n    }\n\n    img {\n      width: 32px;\n      padding-bottom: 40px;\n    }\n\n    &__list {\n      \n      @media only screen and (min-width: 1440px) {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n      }\n\n      &-item {\n        display: flex;\n        gap: 15px;\n        background-color: white;\n        border-radius: 40px;\n        padding: 10px 15px;\n        margin-bottom: 8px;\n        height: 46px;\n        width: fit-content;\n\n        .text {\n          font-size: 11px;\n          padding-top: 4px;\n\n          @media only screen and (min-width: 1440px) {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n\n    &__img {\n      padding-top: 20px;\n      z-index: 3;\n      @media only screen and (min-width: 768px) {\n        width: 50%;\n      }\n\n      img {\n        width: 100%;\n        height: 518px;\n        padding-left: 30px;\n\n        @media only screen and (min-width: 768px) {\n          padding-left: 10px;\n        }\n\n        @media only screen and (min-width: 1440px) {\n          height: 626px;\n          width: 598px;\n          position: absolute;\n          right: 0;\n        }\n      }\n    }\n  }\n\n  &-item {\n    @media only screen and (min-width: 768px) {\n      display: flex;\n    }\n\n    &__img {\n      margin: 24px 0;\n      padding-right: 30px;\n\n      @media only screen and (min-width: 768px) {\n        margin: 64px 0;\n      }\n\n      img {\n        width: 100%;\n\n        @media only screen and (min-width: 768px) {\n          width: 433px;\n        }\n\n        @media only screen and (min-width: 1440px) {\n          width: 821px;\n          height: 310px;\n        }\n      }\n    }\n\n    &__text {\n      color:#757575;\n      font-weight: 400;\n      line-height: 150%;\n      padding: 10px 30px;\n\n      @media only screen and (min-width: 768px) {\n        padding: 64px 30px;\n      }\n    }\n  }\n\n  .badgetitle {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 140%;\n    color: #FCAF17;\n    border-radius: 40px;\n    border: 0.5px solid rgba(0, 0, 0, 0.20);\n    background: rgba(255, 255, 255, 0.20);\n    backdrop-filter: blur(2px);\n    display: inline-block;\n    padding: 4px 16px;\n    margin-bottom: 16px;\n  }\n\n  &-second-area {\n   img {\n    width: 100%;\n    padding: 0 42px;\n   }\n\n   &:nth-of-type(2) {\n    img {\n      margin: 34px 0 80px 0;\n    }\n   }\n  }\n\n  &-right__img {\n    background-color:#F2F2F7;\n    padding: 18px 0;\n\n    .services-item {\n\n      @media only screen and (min-width: 768px) {\n        flex-direction: row-reverse;\n      } \n\n      &__img {\n        padding-right: 0;\n\n        img {\n          padding-left: 30px;\n\n          @media only screen and (min-width: 1440px) {\n            width: 598px;\n            height: 310px;\n\n            &.screen-room {\n              height: 610px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &-content {\n    margin-top: 25px;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 150%;\n\n    @media only screen and (min-width: 1440px) {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    &-item {\n      display: flex;\n      gap: 10px;\n      margin-bottom: 20px;\n      color: #18181C;\n\n      @media only screen and (min-width: 1440px) {\n        background: white;\n        width: max-content;\n        padding: 10px;\n        border-radius: 50px;\n      }\n    }\n  }\n\n  .marklist {\n    grid-template-columns: repeat(4, 1fr);\n    display: grid;\n    margin-top: 24px;\n\n    @media only screen and (min-width: 768px) {\n      grid-template-columns: repeat(4, 50%);\n    } \n\n    @media only screen and (min-width: 1440px) {\n      grid-template-columns: repeat(4, 1fr);\n      margin-top: 0;\n      width: 83%;\n    } \n\n    img {\n      margin: auto;\n      width: 100%;\n      padding-bottom: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
